import Toaster from "global/component/Genericos/Toaster/Toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";

import TazaIcon from "_+_Portal/assets/images/generico/TazaIcon";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { wsPostFilaVirtual } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  ContainerFilaVirtualMasInfo,
  FilaVirtualMasInfoBotones,
  FilaVirtualMasInfoConoceMasTxt,
  FilaVirtualMasInfoIcono,
  FilaVirtualMasInfoTitulo,
  FilaVirtualMasInfoTxt,
} from "./localStyle";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";

const FilaVirtualMasInfo = ({ setError, turnoActual }) => {
  // -------------------------  useContex  ----------------------------
  const {
    pasoDispatch,
    turnosSeleccionadosState,
    filaVirtualDispatch,
    demoraState,
  } = useContext(AutocheckContext);
  const { toasterState, authState } = useContext(GlobalContext);

  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno.medico;
  const especialidad = turno.especialidad;

  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    setPaso("FilaVirtual")(pasoDispatch);
  };
  const callBack = (isCorrect) => {
    if (isCorrect) {
      setPaso("TurnosRecepionados")(pasoDispatch);
    }
  };

  const ingresarFilaVirtual = () => {
    let dtoFilaVirtual = {
      idpaciente: authState.auth.data.paciente.codigo,
      idturno: turno.idturno,
      demorainicial: demoraState.demora.data.demora,
    };
    wsPostFilaVirtual(dtoFilaVirtual, (isCorrect) => callBack(isCorrect))(
      filaVirtualDispatch
    );
  };
  const cancelarFilaVirtual = () => {
    setPaso("TurnosRecepionados")(pasoDispatch);
  };

  // -------------------------  funciones  ----------------------------

  return (
    <LayoutPasos handleClick={volver} type={"no-circle"} title={"FILA VIRTUAL"}>
      {toasterState.toaster.show && <ToasterV2 />}
      <ContainerFilaVirtualMasInfo>
        <CardBlueHeart
          medico={medico ? medico : especialidad}
          turnoTitle={especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        <FilaVirtualMasInfoTitulo>
          <span className="rb18l">
            Para que puedas usar mejor tu tiempo, creamos la fila virtual.
          </span>
        </FilaVirtualMasInfoTitulo>
        <FilaVirtualMasInfoIcono>
          <TazaIcon />
        </FilaVirtualMasInfoIcono>
        <FilaVirtualMasInfoTxt>
          <span className="rb18l">
            Hace lo que necesites y nosotros te avisamos cuando se acerque la
            hora
          </span>
        </FilaVirtualMasInfoTxt>
        <FilaVirtualMasInfoConoceMasTxt>
          <span className="rb18b">
            Es importante activar las notificaciones de nuestra APP.
          </span>
          <span className="FilaVirtualMasInfoConoceMasTxt rb18b">
            Mira como hacerlo acá
          </span>
        </FilaVirtualMasInfoConoceMasTxt>
        <FilaVirtualMasInfoConoceMasTxt>
          <span className="rb18l">
            ¿Le gustaría ingresar a la fila virtual?
          </span>
        </FilaVirtualMasInfoConoceMasTxt>
        <FilaVirtualMasInfoBotones>
          <div
            onClick={ingresarFilaVirtual}
            className="btn bgc-broccoli c-white"
          >
            Si
          </div>
          <div onClick={cancelarFilaVirtual} className="btn bgc-danger c-white">
            No
          </div>
        </FilaVirtualMasInfoBotones>
      </ContainerFilaVirtualMasInfo>
    </LayoutPasos>
  );
};

export default FilaVirtualMasInfo;
